import { When } from 'react-if';
import { Menu } from '@headlessui/react';
import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { logger } from '@zep/core-logger';
import { isDevelopment, isLocal } from '../../../utils';
import S from './Footer.module.scss';
export const FooterMenus = () => {
  const {
    locale
  } = useRouter();
  const {
    user
  } = useAuth();
  const {
    t
  } = useTranslation(['layout'], {
    useSuspense: true
  });
  const isZepDomainUser = isLocal || isDevelopment && user && user.snsId.includes('@zep.us');
  return <div className={S.menu_container} data-sentry-component="FooterMenus" data-sentry-source-file="FooterMenus.tsx">
      <Link href={`https://docs.channel.io/zep-support/${locale}/articles/b40ac18f`} onClick={() => logger.track('footer_term')} prefetch={false} data-sentry-element="Link" data-sentry-source-file="FooterMenus.tsx">
        {t('layout:footer_terms')}
      </Link>
      <span className={S.vertical_bar}>|</span>
      <Link href={`https://docs.channel.io/zep-support/${locale}/articles/8232ed3d`} onClick={() => logger.track('footer_privacy')} prefetch={false} data-sentry-element="Link" data-sentry-source-file="FooterMenus.tsx">
        {t('layout:footer_privacy')}
      </Link>
      <span className={S.vertical_bar}>|</span>
      <When condition={locale === 'ja'} data-sentry-element="When" data-sentry-source-file="FooterMenus.tsx">
        <a href={t('layout:footer.links.specificTransactionsAct') ?? 'https://teamzep.notion.site/ebb58b3378d448febdbdcaf59d833c2a?pvs=4'} target={'_blank'} onClick={() => logger.track('footer_specificTransactionsAct')} rel="noreferrer">
          {t('layout:footer.menus.specificTransactionsAct')}
        </a>
        <span className={S.vertical_bar}>|</span>
      </When>
      <a href={t('layout:footer_update_note_link')} target="_blank" rel="noreferrer" onClick={() => logger.track('footer_update')}>
        {t('layout:footer_patchnote')}
      </a>
      <span className={S.vertical_bar}>|</span>
      <a href={t('layout:footer_guide_link')} target="_blank" rel="noreferrer" onClick={() => logger.track('footer_guide')}>
        {t('layout:footer_guide')}
      </a>
      {locale === 'ko' && <>
          <span className={S.vertical_bar}>|</span>
          <a href="https://zep.career.greetinghr.com/intro" target="_blank" rel="noreferrer" onClick={() => logger.track('footer_recruit')}>
            {t('layout:footer_career')}
          </a>
          <span className={S.vertical_bar}>|</span>
          <a href="https://zep-official-partners.super.site/" target="_blank" rel="noreferrer" onClick={() => logger.track('footer_partners')}>
            {'ZEP 공식 파트너스'}
          </a>
        </>}
      {isZepDomainUser && <>
          <span className={S.vertical_bar}>|</span>
          <Menu>
            <Menu.Button onClick={async () => {
          const name = `Test Sentry Error In ${process.env.NEXT_PUBLIC_STAGE}`;
          if (!window.confirm('센트리 에러 테스트 하시겠습니까?')) {
            return;
          }
          await Sentry.startSpan({
            name,
            op: 'test'
          }, async () => {
            const res = await fetch('/api/sentry-example-api');
            if (!res.ok) {
              throw new Error(name);
            }
          });
        }}>
              센트리 에러
            </Menu.Button>
          </Menu>
        </>}
    </div>;
};